import {
  AlertTriangle,
  BarChart3,
  Building2,
  GitBranch,
  HelpCircle,
  ListFilter,
  Phone,
  PhoneMissed,
  Plug2,
  Settings,
  Users
} from 'lucide-react';

// Иконка живёт здесь, а не отдельной картой в Sidebar: раньше реестров было два, и вкладка,
// добавленная только в один из них, молча рендерилась без значка.
export const APP_TABS = [
  { id: 'dashboard', label: 'Общая статистика', group: 'primary', icon: BarChart3 },
  { id: 'employees', label: 'Сотрудники', group: 'primary', icon: Users },
  { id: 'calls', label: 'Детали звонков', group: 'primary', icon: Phone },
  { id: 'call-paths', label: 'Типы и итоги звонков', group: 'primary', icon: GitBranch },
  { id: 'missed', label: 'Пропущенные', group: 'primary', icon: PhoneMissed },
  { id: 'clients', label: 'Клиенты', group: 'primary', icon: Building2 },
  { id: 'complaints', label: 'Жалобы', group: 'primary', icon: AlertTriangle },
  { id: 'integrations', label: 'Интеграции', group: 'primary', icon: Plug2 },
  // Раздел клиентский, а не административный: список номеров ведут сами пользователи,
  // поэтому он живёт в основной навигации и выдаётся через allowedTabs, а не прячется
  // в «Настройках» вместе с обслуживанием стенда.
  { id: 'number-filters', label: 'Фильтры номеров', group: 'primary', icon: ListFilter },
  { id: 'settings', label: 'Настройки', group: 'secondary', icon: Settings },
  { id: 'help', label: 'Помощь и поддержка', group: 'secondary', icon: HelpCircle }
];

export const APP_TAB_IDS = APP_TABS.map(({ id }) => id);

// Сохранённые права пользователя могут ссылаться на удалённый раздел (так было с «Оценкой
// сотрудников»): такие id отбрасываются, чтобы не рисовать их сырыми и не сохранять обратно.
export const pickKnownTabIds = (tabIds) =>
  Array.isArray(tabIds) ? tabIds.filter((tabId) => APP_TAB_IDS.includes(tabId)) : [];

export const PRIMARY_APP_TABS = APP_TABS.filter(({ group }) => group === 'primary');
export const SECONDARY_APP_TABS = APP_TABS.filter(({ group }) => group === 'secondary');
